<div *ngIf="!alertClosed" class="wvr-components wvr-alert alert alert-{{themeVariant}}" role="alert">

  <div *ngIf="alertType==='basic'" class="basic flex-fill align-self-stretch">
    <ng-container *ngTemplateOutlet="closeButton"></ng-container>
    <ng-container *ngTemplateOutlet="basic"></ng-container>
  </div>

  <div *ngIf="alertType==='self-closing'" class="self-closing flex-fill align-self-stretch">
    <ng-container *ngTemplateOutlet="selfClosing"></ng-container>
  </div>

  <div *ngIf="alertType==='custom'" class="custom flex-fill align-self-stretch">
    <ng-container *ngTemplateOutlet="closeButton"></ng-container>
    <ng-container *ngTemplateOutlet="custom"></ng-container>
  </div>

</div>

<ng-template #basic>
  <div [wvrContentProjection]="eRef" template="alert-content"></div>
</ng-template>

<ng-template #selfClosing>
  <div class="alert-dismissible" (close)="alertClosed = true">
    <ng-container *ngTemplateOutlet="basic"></ng-container>
  </div>
</ng-template>

<ng-template #custom>
  <div [wvrContentProjection]="eRef" template="custom-alert-content"></div>
</ng-template>

<ng-template #closeButton>
  <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="clickClose($event)" *ngIf="closeable === 'true'">
    <wvr-text-component aria-hidden="true" value="&times;"></wvr-text-component>
  </button>
</ng-template>

<ng-content select="template"></ng-content>
